import { useMainStore } from '../composables/store.js'
import { getCurrentServer } from './globalData.js'
import { filterTrafficItemListResponse, resolveTrafficItemFilterConfig } from './goodsFilter.js'

export function filterGoodsListResponse(response, headers = {}) {
  const store = useMainStore()
  const storeInfoMap = store?.$state?.storeInfoDataMap || {}
  const storeInfo = storeInfoMap[getCurrentServer(headers)]
    || Object.values(storeInfoMap).find(item => item?.id)
    || {}
  let storedStoreInfo = {}
  let storedFollowInfo = {}

  if (typeof window !== 'undefined') {
    try {
      storedStoreInfo = window.localStorage.getItem('StoreInformation') || {}
      storedFollowInfo = window.localStorage.getItem('offiaccountFollowUrl') || {}
    }
    catch {
      // The current store configuration remains available without browser storage.
    }
  }

  const config = resolveTrafficItemFilterConfig(storeInfo, storedStoreInfo, storedFollowInfo)
  return filterTrafficItemListResponse(response, config)
}
